export const UPDATE_USSD_ACCOUNT_STATUS = `
mutation UpdateUssdAccount($id: ID!, $accountStatus: Int, $hashedPin: String) {
  updateUssdAccount(id: $id, accountStatus: $accountStatus, hashedPin: $hashedPin) {
    ussdAccount {
      id
      accountStatus
      hashedPin
      phone {
        number
      }
      customer {
        id
        petraId
        fullname
      }
    }
    errors {
      property
      description
    }
  }
} 
`;

export const RESET_USSD_ACCOUNT_PIN = `
mutation ResetUssdAccountPin($id: ID!) {
  resetUssdAccountPin(id: $id) {
    ussdAccount {
      id
      accountStatus
      hashedPin
      phone {
        number
      }
    }
    errors {
      property
      description
    }
  }
} 
`;

export const GET_USSD_ACCOUNTS = `
    query ussdAccountSearch($page: ID!, $q: String) {
        ussdAccountSearch(page: $page, q: $q) {
            count
            errors{
                description
                property
            }
            results{
                accountStatus
                customer{
                    petraId
                    fullname
                    id
                }
                hashedPin
                id
                phone{
                    number
                }
            }
        }
    }
`;

export const UPDATE_USSD_ACCOUNT_PHONE = `
mutation updateUssdAccountPhone($ussdAccountId: ID!, $phoneNumber: String!) {
  updateUssdAccountPhone(ussdAccountId: $ussdAccountId, phoneNumber: $phoneNumber) {
    ussdAccount {
      id
      accountStatus
      hashedPin
      phone {
        number
      }
      customer{
        id
        petraId
        fullname
      }
    }
    errors {
      property
      description
    }
  }
} 
`;